import ModalTitleContainer from "../../../../components/Modal/components/ModalTitleContainer";
import dayjs from "dayjs";
import {StyledButton} from "../../../../components/Buttons/DefaultButton/DefaultButton.styles";
import React, {FC} from "react";
import {JobWithInvoiceProps} from "../InvoicePage";
import {ShiftContainer} from "../InvoicePage.styles";
import { formatInvoiceCents, getInvoicePayNowQuote } from 'utils/invoicePayNowQuote';

interface PayInvoiceProps {
    job: JobWithInvoiceProps;
    onPayInvoice: () => void;
    onCloseButtonClick: () => void;

}

export const PayInvoiceModal: FC<PayInvoiceProps> = (
    {
        job: data,
        onPayInvoice,
        onCloseButtonClick
    }) => {
    const quote = getInvoicePayNowQuote(data.invoice);
    
    return (
        <>
            <ModalTitleContainer title={'Pay This Invoice?'} onClose={onCloseButtonClick} />

            {quote ? <ShiftContainer>
                We will process payment for this invoice and forward it directly to {data.hygienist.firstName}.
                {!quote.feeWaived && (
                    <> A small processing fee of {quote.feeBasisPoints / 100}% applies to the payment, just to cover our transaction costs of sending this payment to {data.hygienist.firstName}.</>
                )}
                <br/><br/><b>Invoice #{data.invoice.jobId}</b>
                <br/><b>Date:</b> {dayjs.utc(data.startDate).format('MMM D, YYYY')}
                <br/><b>Invoice Amount:</b> ${formatInvoiceCents(quote.baseAmountCents)}
                <br/><b>Processing Fee:</b> ${formatInvoiceCents(quote.feeAmountCents)}{!quote.feeWaived && ` (${quote.feeBasisPoints / 100}%)`}
                <br /><br /><b data-testid="invoice-confirmation-total">Total Payable: ${formatInvoiceCents(quote.officeAmountCents)} {quote.currency.toUpperCase()}</b>
                <br /><br />Once payment is successfully processed, we'll e-mail you a copy of the paid invoice receipt.
                Payment is secure using bank-level encryption. Pay now?
            </ShiftContainer> : <ShiftContainer>Could not load the payment total. Please close and reopen this invoice.</ShiftContainer>}

            <StyledButton
                variant="contained"
                color="primary"
                size="large"
                data-testid="invoice-payment-confirm"
                disabled={!quote}
                onClick={onPayInvoice}
            >
                Confirm
            </StyledButton>
            <StyledButton
                variant="outlined"
                color="primary"
                size="large"
                data-testid="invoice-payment-cancel"
                onClick={onCloseButtonClick}
            >
                Cancel
            </StyledButton>
        </>
    );
}
